import { render, staticRenderFns } from "./EditSortNumberDialog.vue?vue&type=template&id=1792919e&scoped=true"
import script from "./EditSortNumberDialog.vue?vue&type=script&lang=ts"
export * from "./EditSortNumberDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditSortNumberDialog.vue?vue&type=style&index=0&id=1792919e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792919e",
  null
  
)

export default component.exports